<template>
	<PageHeaderLayout class="new-key-result-header">
		<template #left>
			<TeamingButton
				class="new-key-result-header__cancel-left"
				:disabled="disabled"
				size="SMALL"
				type="QUATERNARY"
				@click="onCancelClicked"
			>
				{{ $t( "common-gokr.components.NewKeyResultHeader.cancelButton" ) }}
			</TeamingButton>
		</template>
		<template #title>
			{{ $t( "common-gokr.components.NewKeyResultHeader.title" ) }}
		</template>
		<template #right>
			<div class="new-key-result-header__buttons">
				<TeamingButton
					class="new-key-result-header__cancel-right"
					:disabled="disabled"
					size="SMALL"
					type="QUATERNARY"
					@click="onCancelClicked"
				>
					{{ $t( "common-gokr.components.NewKeyResultHeader.cancelButton" ) }}
				</TeamingButton>
				<TeamingButton
					:disabled="disabled"
					size="SMALL"
					@click="onSaveClicked"
				>
					{{ $t( "common-gokr.components.NewKeyResultHeader.saveButton" ) }}
				</TeamingButton>
			</div>
		</template>
	</PageHeaderLayout>
</template>

<script>
import { PageHeaderLayout, TeamingButton } from "@teaming/common-ui";
export default {
	name: "NewKeyResultHeader",
	emits: [ "cancel", "save", ],
	components: {
		PageHeaderLayout,
		TeamingButton,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		onCancelClicked() {
			this.$emit( "cancel" );
		},
		onSaveClicked() {
			this.$emit( "save" );
		},
	},
};
</script>

<style lang="scss" scoped>
.new-key-result-header__buttons {
	display: flex;
	justify-content: flex-end;
	gap: 1rem;
}

.new-key-result-header__cancel-right {
	display: none;

	@include for-size('md') {
		display: flex;
	}
}
</style>
